export default function CalcPercenteProgressBar(
  percentStatusConfiguration,
  occupate,
  disponibili
) {
  let percent = (occupate / disponibili) * 100;
  percent = Math.round(percent)
  
  if(isNaN(percent)) percent = 0;

  return progressBarStatus(percentStatusConfiguration, percent);
}

function progressBarStatus(configuration, valueProgressBar) {
  const { lowStatus, mediumStatus } = configuration;

  //i colori sono configurati a livello di Thema di mui.
  if (valueProgressBar <= lowStatus) {
    return { valueProgressBar, colorProgressbar: "customSuccess" };
  }

  if (valueProgressBar <= mediumStatus) {
    return { valueProgressBar, colorProgressbar: "customWarning" };
  }

  return { valueProgressBar, colorProgressbar: "customError" };
}
